/** Shared keys keep gameplay invalidation independent of the expedition command hook. */
export const tribeExpeditionQueryKey = (tribeId: string) =>
  ['tribe', tribeId, 'expeditions'] as const;

export const tribeAssistanceQueryKey = (tribeId: string) =>
  ['tribe', tribeId, 'assistance'] as const;

export const tribeSocialQueryKey = (tribeId: string) => ['tribe', tribeId, 'social'] as const;
